import React from 'react';

const hasChildren = (children: React.ReactNode | React.ReactNodeArray): boolean =>
  !(
    children === null ||
    children === undefined ||
    (Array.isArray(children) && children.length === 0)
  );

const getUnusedProps = <Props extends Record<string, unknown>>(
  definedProps: Partial<Props>,
  allProps: Props
): Partial<Props> =>
  Object.keys(allProps).reduce<Partial<Props>>((acc, prop: keyof Props) => {
    if (!Object.prototype.hasOwnProperty.call(definedProps, prop)) acc[prop] = allProps[prop];
    return acc;
  }, {});

export default {
  getUnusedProps,
  hasChildren,
};
